var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M16 30.2614C23.3638 30.2614 29.3333 24.2919 29.3333 16.9281C29.3333 9.56426 23.3638 3.59473 16 3.59473C8.63619 3.59473 2.66666 9.56426 2.66666 16.9281C2.66666 24.2919 8.63619 30.2614 16 30.2614Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 10.1689C13.24 10.1689 11 12.4089 11 15.1689C11 17.8756 13.12 20.0756 15.9333 20.1556C15.9733 20.1556 16.0267 20.1556 16.0533 20.1556C16.08 20.1556 16.12 20.1556 16.1467 20.1556C16.16 20.1556 16.1733 20.1556 16.1733 20.1556C18.8667 20.0623 20.9867 17.8756 21 15.1689C21 12.4089 18.76 10.1689 16 10.1689Z",
    fill: "#A2A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.04 26.7287C22.6667 28.9154 19.4933 30.262 16 30.262C12.5067 30.262 9.33332 28.9154 6.95999 26.7287C7.27999 25.5154 8.14666 24.4087 9.41333 23.5554C13.0533 21.1287 18.9733 21.1287 22.5867 23.5554C23.8667 24.4087 24.72 25.5154 25.04 26.7287Z",
    fill: "#A2A2A8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.e84d8e25bae8b0f68edf8688ca593f89.svg";
export { ForwardRef as ReactComponent };